import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUpdateChallenge = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ file, id }) => {
      const formData = new FormData();
      formData.append('file', file);

      const result = await restClient({
        url: `${prefix}/challenge-definitions/${id}`,
        method: 'PUT',
        data: formData
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch challenges list after successful update
      queryClient.invalidateQueries({ queryKey: ['resultsChallenges'] });
    },
    onError: (error) => {
      console.error('Error updating challenge:', error);
    }
  });
};
